import { render, staticRenderFns } from "./LayersHeader.vue?vue&type=template&id=6f0e8510&scoped=true"
import script from "./LayersHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayersHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LayersHeader.vue?vue&type=style&index=0&id=6f0e8510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e8510",
  null
  
)

export default component.exports